import { any, array, object } from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { Text } from '@sitecore-jss/sitecore-jss-react';

const mapStateToProps = (state) => {
  const currentCustomCart = state.productReducer.cartDetailReducer.currentCartCustom || null;
  const clientSOCartCustomData = state.personalizeOfferReducer.getClientSOCartReducer.customData || null;

  return {
    cartData: clientSOCartCustomData || currentCustomCart,
    visitorCartData: state.myOrderReducer.orderByIdReducer.currentCartCustom,
    availabilityStores: state.bopisReducer.getAvailabilityStoresReducer.data
  };
};

export const StorePickUpSelected = connect(mapStateToProps)(
  ({
    layoutData,
    cartData,
    visitorCartData,
    availabilityStores
  }) => {
    const addressLine = useMemo(
      () => cartData?.PickUpStore?.[0]?.Address || visitorCartData?.PickUpStore?.[0]?.Address,
      [cartData, visitorCartData]
    );

    const storeSelectedData = useMemo(() => availabilityStores?.find((store) => store.OutletId
      === addressLine?.PickUpStoreId), [availabilityStores, addressLine]);

    return (
      storeSelectedData || addressLine
    ) ? (
        <div className='address-component__line2'>
          {storeSelectedData?.Name ? <span>{storeSelectedData.Name}</span> : (
            <></>
          )}

          {storeSelectedData?.Street ? (
            <span>{storeSelectedData.Street}</span>
          ) : (
            <span
              dangerouslySetInnerHTML={{
                __html: addressLine?.FullAddress
              }}
            />
          )}

          {storeSelectedData ? (
            <span>{storeSelectedData.Postcode}</span>
          ) : (
            <></>
          )}

          <span>
            <Text field={layoutData?.['Phone Number']} />: {storeSelectedData?.Phone || addressLine?.PhoneNumber}
          </span>
        </div>
      ) : (
        <Text tag='p' field={layoutData?.['BOPIS No Address Message']} className='address-component__no-address' />
      );
  });

StorePickUpSelected.propTypes = {
  layoutData: any,
  cartData: object,
  visitorCartData: object,
  availabilityStores: array
};